module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-5.3ca2f1a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-5.jpg
// module id = 1891
// module chunks = 2